export enum DateRadioPickerOptionColor {
  RED = 'red',
  YELLOW = 'yellow',
  GREEN = 'green'
}

export interface DateRadioPickerOption {
  name: string;
  value: string;
  color?: DateRadioPickerOptionColor;
}

export interface DateRadioPickerDayState {
  date: Date;
  option?: DateRadioPickerOption;
}